import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from 'utils/api';
export function getMindsetAuthToken() {
  return _getMindsetAuthToken.apply(this, arguments);
}
function _getMindsetAuthToken() {
  _getMindsetAuthToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$api, authToken;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return api('get', '/api/mindset/authToken');
        case 1:
          _yield$api = _context.sent;
          authToken = _yield$api.authToken;
          return _context.abrupt("return", authToken);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMindsetAuthToken.apply(this, arguments);
}